<ng-container *ngIf="!this.currentOrganization?.country; else showLocationForm">
  <div class="grid box-section blue p-5 mb-5">
    <div class="col-12">
      <div class="grid justify-content-center">
        <a [routerLink]="['/', 'company-information']" class="col-12 outlined">
          <h3>
            <span class="material-icons-outlined icon-span"> business </span>
            Update Company Country
          </h3>
          <p>
            The company profile does not have a
            <strong>country</strong> associated with it please update your
            profile.
          </p></a
        >
      </div>
    </div>
  </div>
</ng-container>

<ng-template #showLocationForm>
  <form [formGroup]="locationFormGroup">
    <div class="flex flex-wrap align-items-stretch">
      <div class="flex col-12 md:col-4">
        <div
          class="col-12 border-1 border-400 border-round-xl surface-ground p-4 mb-3"
        >
          <p-divider>
            <div class="p-d-inline-flex align-items-center">
              <b>Location Details:</b>
            </div>
          </p-divider>

          <div class="formgrid grid">
            <div class="field col-12 md:col-6">
              <input formControlName="name" id="name" pInputText type="text" />
            </div>

            <div class="field col-12 md:col-6 text-right">
              <p-dropdown
                [options]="binary"
                optionLabel="name"
                optionValue="value"
                formControlName="active"
              ></p-dropdown>
            </div>

            <div class="field grid justify-content-end" *ngIf="false">
              <div class="col-10 mb-2 md:col-10 p-mb-md:col-0">
                This location is head office:
              </div>
              <div class="col-2 md:col-2 text-right">
                <p-inputSwitch formControlName="isHeadOffice"></p-inputSwitch>
              </div>
            </div>
          </div>

          <p-divider>
            <div class="p-d-inline-flex align-items-center">
              <i class="pi pi-clock mr-2"></i>
              <b>Opening and Closing Times</b>
            </div>
          </p-divider>
          <div class="grid justify-content-center">
            <div class="field col-6">
              <label for="openingTime">Opening Time:</label>
              <span class="p-fluid">
                <p-calendar
                  [defaultDate]="defaultOpeningTime"
                  [timeOnly]="true"
                  dataType="string"
                  formControlName="openingTime"
                  id="openingTime"
                  name="openingTime"
                ></p-calendar>
              </span>
            </div>
            <div class="field col-6">
              <label for="closingTime">Closing Time:</label>
              <span class="p-fluid">
                <p-calendar
                  [defaultDate]="defaultClosingTime"
                  [timeOnly]="true"
                  dataType="string"
                  formControlName="closingTime"
                  id="closingTime"
                  name="closingTime"
                ></p-calendar>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="flex col-12 md:col-4">
        <div
          class="col-12 border-1 border-400 border-round-xl surface-ground p-4 mb-3"
        >
          <p-divider>
            <div class="p-d-inline-flex align-items-center">
              <i class="pi pi-question-circle mr-2"></i>
              <b>Location will be used for:</b>
            </div>
          </p-divider>

          <div class="formgrid grid">
            <div class="field col-12">
              <div class="field-checkbox" style="width: 100%">
                <p-checkbox
                  [(ngModel)]="selectedValues"
                  [ngModelOptions]="{ standalone: true }"
                  name="locationtype"
                  value="pos"
                  [disabled]="this.selectedUsageType === 5"
                  (click)="handleLocationUseChange()"
                >
                </p-checkbox>

                <label class="flex align-items-center" style="width: 100%">
                  <span
                    ><strong>Point of Sale:</strong> Sales will be made directly
                    to customers from this location.</span
                  >
                  <span
                    pTooltip="You will be using this location to make sales to customers face to face with the Boma POS"
                    tooltipPosition="left"
                    class="ml-2"
                    ><i class="pi pi-question-circle"></i
                  ></span>
                </label>
              </div>
            </div>

            <div class="field col-12">
              <div class="field-checkbox w-100">
                <p-checkbox
                  [(ngModel)]="selectedValues"
                  [ngModelOptions]="{ standalone: true }"
                  name="locationtype"
                  value="orders"
                  [disabled]="this.selectedUsageType === 5"
                  (click)="handleLocationUseChange()"
                >
                </p-checkbox>

                <label class="flex align-items-center w-100" id="online-orders">
                  <span
                    ><strong>Order Fulfilment:</strong> Orders can be placed at
                    this location which will be picked packed and dispatched
                    from this location.</span
                  >
                  <span
                    pTooltip="This location will be able to receive orders made by users using the mobile app or the online store."
                    tooltipPosition="left"
                    class="ml-2"
                    ><i class="pi pi-question-circle"></i
                  ></span>
                </label>
              </div>
            </div>

            <div class="field col-12">
              <div class="field-checkbox w-100">
                <p-checkbox
                  [(ngModel)]="selectedValues"
                  [ngModelOptions]="{ standalone: true }"
                  name="locationtype"
                  value="production"
                  (click)="handleLocationUseChange()"
                >
                </p-checkbox>

                <label class="flex align-items-center w-100">
                  <span
                    ><strong>Production:</strong> Stock gets produced
                    here.</span
                  >
                  <span
                    pTooltip="Using this location type will allow you to keep track of produced stock on the stock movement report."
                    tooltipPosition="left"
                    class="ml-2"
                    ><i class="pi pi-question-circle"></i
                  ></span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex col-12 md:col-4">
        <div
          class="col-12 border-1 border-400 border-round-xl surface-ground p-4 mb-3"
        >
          <p-divider>
            <div class="p-d-inline-flex align-items-center">
              <i class="pi pi-user mr-2"></i>
              <b *ngIf="customerLocation"
                >Customer Contact Details for this Location?</b
              >
              <b *ngIf="!customerLocation"
                >Who is the main contact for this location?</b
              >
            </div>
          </p-divider>
          <div class="formgrid grid">
            <div class="field col-12" *ngIf="!customerLocation">
              <boma-search-entity-users
                (sendSelectedUser)="handleSelectedUser($event)"
                placeHolderText="Search Users"
                [showLabels]="false"
                [simpleDropDown]="false"
              ></boma-search-entity-users>
            </div>

            <div class="field col md:col-6">
              <label for="contactPersonName">Contact Person Name:</label>
              <input
                formControlName="contactPersonName"
                id="contactPersonName"
                pInputText
                type="text"
                class="w-full"
              />
            </div>

            <div class="field col md:col-6">
              <label for="contactPersonNumber">Contact Person Number:</label>
              <input
                formControlName="contactPersonNumber"
                id="contactPersonNumber"
                pInputText
                type="text"
                class="w-full"
              />
            </div>

            <div class="field col-12">
              <label for="notificationEmailAddress"
                >Notification Email Address:</label
              >
              <input
                formControlName="notificationEmailAddress"
                id="notificationEmailAddress"
                pInputText
                type="text"
                class="w-full"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="grid">
      <div
        class="col-12 border-1 border-400 border-round-xl surface-ground p-4"
      >
        <div class="grid justify-content-center">
          <div class="field col-12 p-0">
            <p-divider>
              <div class="p-d-inline-flex align-items-center">
                <i class="material-icons-round mi-location-on mr-2"></i>
                <b>Geo Location and Address</b>
              </div>
            </p-divider>
          </div>

          <div class="field col-12">
            <boma-update-location
              (setPoint)="handleClick($event)"
              (setPolygon)="handleSetPolygon($event)"
              [location]="location"
              [country]="country"
              [showBoundary]="!customerLocation"
              [allowEdit]="true"
              [update]="newLocation"
            ></boma-update-location>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="grid justify-content-center">
          <div *ngIf="!this.locationFormGroup.valid" class="field col-12">
            <p-messages severity="warn">
              <ng-template pTemplate>
                <div class="ml-2">
                  Please ensure that all the inputs are completed, else you will
                  not be able to save this location.
                </div>
              </ng-template>
            </p-messages>
          </div>
          <div class="field col-12">
            <div class="flex justify-content-end">
              <!-- This div is required to not full with the button shrug -->

              <div>
                <p-button
                  (click)="save()"
                  [disabled]="!this.locationFormGroup.valid || isSubmitting"
                  [icon]="
                    isSubmitting ? 'pi pi-spin pi-spinner' : 'pi pi-check'
                  "
                  [label]="newLocation ? 'Create Location' : 'Save Location'"
                  iconPos="left"
                ></p-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-template>
